// ============================================================================
// GERMAN TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Nachdenkliche und interessante Fragen über den Glauben

export const funQuestions = [
  {
    question: "Welche Liebestat Jesu inspiriert dich am meisten in deinem täglichen Leben?",
    emoji: "❤️",
    theme: "liebe"
  },
  {
    question: "Wenn du mit einer biblischen Figur eine Mahlzeit teilen könntest, wer wäre es und warum?",
    emoji: "🍞",
    theme: "begegnung"
  },
  {
    question: "Welches Gleichnis Jesu spricht dich am tiefsten an und warum?",
    emoji: "🌱",
    theme: "lehre"
  },
  {
    question: "Wie zeigt sich Gottes Friede in deinem Leben?",
    emoji: "🕊️",
    theme: "friede"
  },
  {
    question: "Welches Wunder Jesu hättest du gerne miterlebt?",
    emoji: "✨",
    theme: "glaube"
  },
  {
    question: "Wenn du Gottes Liebe in einem Wort beschreiben müsstest, welches wäre es?",
    emoji: "💝",
    theme: "göttliche liebe"
  },
  {
    question: "Welcher Bibelvers hat dir in einer schwierigen Zeit geholfen?",
    emoji: "📖",
    theme: "trost"
  },
  {
    question: "Wie kannst du heute Licht der Welt sein?",
    emoji: "💡",
    theme: "zeugnis"
  }
];

export default funQuestions;
